import React from 'react';
import { Users, Puzzle, TrendingUp, UserPlus, Target, MessageSquare } from 'lucide-react';
import './BusinessValueShowcase.css';

const BusinessValueShowcase = () => {
  const services = [
    {
      icon: <Users size={40} />,
      title: "Employee Search",
      description: "Objectively pursue diverse catalysts for change for interoperable meta-services.",
      color: "#c94449"
    },
    {
      icon: <Puzzle size={40} />,
      title: "People Cohesion",
      description: "More and less froze grumbled ran hawk mindfully tearfully pending crud.",
      color: "#3d4450"
    },
    {
      icon: <UserPlus size={40} />,
      title: "Team Leadership",
      description: "A less until infallible indistinct decided inventoried gosh hey some contemplated.",
      color: "#c94449"
    },
    {
      icon: <TrendingUp size={40} />,
      title: "Team Build Up",
      description: "Irritably punctiliously ahead far away groundhog darn contrary and fish underneath.",
      color: "#3d4450"
    },
    {
      icon: <Target size={40} />,
      title: "Strategy",
      description: "Jeez alas after squarely excellent incessant on less vulgarly checked pertly.",
      color: "#c94449"
    },
    {
      icon: <MessageSquare size={40} />,
      title: "Communication",
      description: "Flustered precarious jeez unexpectedly overrode glowered away goodness.",
      color: "#3d4450"
    }
  ];

  return (
    <div className="showcase-container">
      <div className="showcase-header">
        <p className="showcase-subtitle">WHERE DID WE PROVE OUR WORTH</p>
        <h1 className="showcase-title">
          <span className="title-red">Businesses helped</span>
          <span className="title-dark">By Humanex</span>
        </h1>
        <p className="showcase-description">
          Bring to the table win-win survival strategies to ensure proactive
          domination. At the end of the day, going forward, a new normal that has
          evolved from generation.
        </p>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="icon-wrapper" style={{ backgroundColor: service.color }}>
              {service.icon}
            </div>
            <div className="service-content">
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessValueShowcase;